import { PageLayoutFooter } from '@angeplus/prever-component-lib';

import { PrivacyPolicy } from '../modules/terms/PrivacyPolicy';
import { PAGE_TITLE } from '../utils/pageTitle';

export default function PrivacyPolicyPage() {
  return (
    <PageLayoutFooter title={PAGE_TITLE.privacyPolicy}>
      <PrivacyPolicy />
    </PageLayoutFooter>
  );
}
